import EditDeleteFooter from './EditDeleteFooter';
import React, { useState } from 'react';
import { api } from '../services/api';
import DeleteModal from './DeleteModal';
function UpdateFooter({ update, loadReviews, toast }) {
    const [showDelete, setShowDelete] = useState(false);
    const [deleteAnswer, setDeleteAnswer] = useState('');
    const [deleting, setDeleting] = useState(false);
    const closeDelete = () => {
        setShowDelete(false)
    }
    const openDelete = () => {
        console.log("***openDelete***")
        setDeleting(false);
        setDeleteAnswer("")
        setShowDelete(true)
    }
    const deleteUpdate = (e) => {
        e.preventDefault();
        api.deleteUpdate(update.id)
            .then(res => {
                toast("Succesfully Deleted");
                closeDelete();
                loadReviews();
            }).finally(() => {
                setDeleting(false);
            })
    }
    return (
        <React.Fragment>
            <DeleteModal
                deleteAnswer={deleteAnswer}
                setDeleteAnswer={setDeleteAnswer}
                deleteAsset={deleteUpdate}
                showDelete={showDelete}
                deleting={deleting}
                closeDelete={closeDelete}
                assetType="update"
            />
            <EditDeleteFooter
                to={`/update/${update.id}/edit`}
                openDelete={openDelete}
            />
        </React.Fragment>
    )
}

export default UpdateFooter;